"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
export class Controller {
}
let ContentModeSwitch = class extends Vue {
  changeMode() {
    localStorage.setItem("vd_mode", this._contentController.mode);
  }
};
__decorateClass([
  PropSync("owner")
], ContentModeSwitch.prototype, "_contentController", 2);
ContentModeSwitch = __decorateClass([
  Component({})
], ContentModeSwitch);
export {
  ContentModeSwitch as default
};
